<template>
  <div>
  <!-- MAIN -->
  <div class="breadcrumbs ace-save-state" id="breadcrumbs">
    <ul class="breadcrumb">
      <li>
        <i class="ace-icon fa fa-home home-icon"></i>
        <a href="#/">メインメニュー</a>
      </li>
      <router-link tag="li" :to="{name: 'useredit', query: { id: userId }}">
        <a>ユーザー編集</a>
      </router-link>
      <li class="active">解錠可能ゲートを追加</li>
    </ul><!-- /.breadcrumb -->
  </div>
  <div class="page-header">
    <div class="checkbox">
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace groupName" checked="checked" @click="addRomoveScorp('groupName', 'name')">
        <span class="lbl">グループ名</span>
      </label>
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace groupId" checked="checked" @click="addRomoveScorp('groupId', 'groupId')">
        <span class="lbl">グループID</span>
      </label>
      <span class="input-icon search-box">
        <input type="text" placeholder="選択項目にチェックして検索" class="nav-search-input" id="nav-search-input" autocomplete="off">
        <i class="ace-icon fa fa-search nav-search-icon"></i>
      </span>
      <button class="btn-cusstom green-btn" type="button" @click="search()">検索</button>
      <button class="btn-cusstom green-btn" type="button" href="#process" data-toggle="modal" @click="resetStatus()">チェックしたゲートグループを追加する</button>
      <button class="btn-cusstom black-btn pull-right" type="button" @click="cancel()">ユーザー編集画面に戻る</button>
    </div>
  </div><!-- /.page-header -->
  <!-- END MAIN -->
  <div class="page-content">
    <div class="alert alert-danger" v-if="errorMessageLogs!==''">
      {{ errorMessageLogs }}
    </div>
    <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
    <div class="scroll-data-content">
        <div class="pull-right">
          <a class="option_button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="false">表示オプション&nbsp;
            <i class="bigger-110 ace-icon fa fa-angle-down" data-icon-hide="ace-icon fa fa-angle-up" data-icon-show="ace-icon fa fa-angle-down"></i>
          </a>
        </div>
        <div class="clearfix" style="clear:both">
          <div id="accordion">
            <div class="panel-collapse collapse" id="collapseOne" aria-expanded="false" style="height: 0px;">
              <div class="panel-body">
                <div class="control-group">
                  <label class="control-label bolder blue display_block">表示項目</label>
                  <div class="checkbox table_items">
                    <label>
                      <input name="group_id" type="checkbox" class="ace" disabled checked="checked">
                      <span class="lbl">グループID</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="group_name" type="checkbox" class="ace" checked="checked" v-model="checkedColumnNames" value="groupName">
                      <span class="lbl"> グループ名</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="group_status" type="checkbox" class="ace" @click="ShowHideColumn" checked="checked" v-model="checkedColumnNames" value="status">
                      <span class="lbl">ステータス</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="group_date" type="checkbox" class="ace" @click="ShowHideColumn" checked="checked" v-model="checkedColumnNames" value="registered">
                      <span class="lbl">登録日</span>
                    </label>
                  </div>
                </div>
                <div class="control-group">
                  <label class="control-label bolder blue display_block">ページごとに表示する項目数</label>
                  <select id="pageSizeOptions" class="first-child last-child" @change="handleSizeChange" v-model="selected">
                    <option v-for="pageSize in pageSizeOptions" v-bind:value="pageSize" v-bind:key="pageSize">
                    {{ pageSize }} 件
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <table id="simple-table" class="table  table-bordered table-hover dataTable" v-if="list!=null">
          <thead>
            <tr>
              <th class="center">
                <label class="pos-rel">
                  <input type="checkbox" class="ace" v-model="selectAll">
                  <span class="lbl"></span>
                </label>
              </th>
              <th id="group-id" class="group_id sorting" @click="sort('groupId', 'group-id')">グループID</th>
              <th id="group-name" class="group_name sorting" @click="sort('name', 'group-name')" v-bind:class="{'none': checkColumnShowHide('groupName')}">グループ名</th>
              <th id="group-status" class="center group_status sorting" @click="sort('isValid', 'group-status')" v-bind:class="{'none': checkColumnShowHide('status')}">ステータス</th>
              <th id="group-date" class="center group_date sorting" @click="sort('registered', 'group-date')" v-bind:class="{'none': checkColumnShowHide('registered')}">登録日</th>
            </tr>
          </thead>
          <tbody v-for="(item, index) in list" :key="index">
            <tr class="existItem" v-bind:class="{'selected': rowSelectedExistPassage(item.groupId)}" :id="item.groupId" v-if="rowSelectedExistPassage(item.groupId)">
              <td class="center">
                <label class="pos-rel">
                  <input type="checkbox" class="ace" :value="item.groupId" disabled v-model="existGroupId">
                  <span class="lbl"></span>
                </label>
              </td>
              <td class="group_id" @click="showdetail">{{item.groupId}}</td>
              <td class="group_name" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('groupName')}">
                {{item.name}}
              </td>
              <td class="center group_status" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('status')}">
                <span v-if="item.isValid">有効</span>
                <span v-else >無効</span>
              </td>
              <td class="center group_date" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('registered')}">
                {{ converDate(item.registered) }}
              </td>
            </tr>
            <tr v-bind:class="{'selected': rowSelected(item.groupId)}" :id="item.groupId" v-else>
              <td class="center">
                <label class="pos-rel">
                  <input type="checkbox" class="ace" :value="item.groupId" v-model="selectedGroupId">
                  <span class="lbl"></span>
                </label>
              </td>
              <td class="group_id" @click="showdetail">{{item.groupId}}</td>
              <td class="group_name" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('groupName')}">
                {{item.name}}
              </td>
              <td class="center group_status" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('status')}">
                <span v-if="item.isValid">有効</span>
                <span v-else >無効</span>
              </td>
              <td class="center group_date" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('registered')}">
                {{ converDate(item.registered) }}
              </td>
            </tr>
          </tbody>
        </table>
        <table id="simple-table" class="table  table-bordered table-hover dataTable" v-else>
          <thead>
            <tr>
              <th class="center">
                <label class="pos-rel">
                  <input type="checkbox" class="ace">
                  <span class="lbl"></span>
                </label>
              </th>
              <th id="group-id">グループID</th>
              <th id="group-name">グループ名</th>
              <!--<th class="center userItem">所属ユーザー数</th>
              <th class="center gateItem">登録ゲート数</th>-->
              <th id="group-status">ステータス</th>
              <th id="group-date" class="center">登録日</th>
            </tr>
          </thead>
          <tbody>
            <tr><td colspan="5">{{message}}</td></tr>
          </tbody>
        </table>
    </div><!-- /.row -->
    <div class="row pd-t-10">
      <div class="col-xs-12">
        <div class="dataTables_paginate paging_simple_numbers" v-if="pages>0">
          <paginate
            :page-count="pages"
            :page-range="3"
            :margin-pages="2"
            :click-handler="handleCurrentChange"
            :prev-text="'<<'"
            :next-text="'>>'"
            :container-class="'pagination'"
            :page-class="'page-item'">
          </paginate>
        </div>
      </div>
    </div>
  </div>
  <!-- プロフィールModal -->
  <div id="process" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
          <h3 class="smaller lighter frofile-title no-margin">解錠可能ゲートを追加</h3>
        </div>
        <div class="modal-body">
          <span class="progress-question">チェックしたゲートグループを追加する、よろしいですか？</span>
          <div class="progress" v-bind:class="{'progress-striped':!success , active:!success, hide:!success}">
            <div class="progress-bar" :style="progressWidth">
            <span>{{ Math.round(progress) }}%</span>
            </div>
          </div>
          <span class="success-label" v-if="successGateGroup>0">{{countGateGroup}}件中{{successGateGroup}}件を追加しました。</span>
          <div v-if="errorMessage.length>0">
          <span class="error-box-title">追加失敗</span>
          <div class="error-box">
            <template v-for="item in errorMessage">
              <p v-html="item" :key="item"></p>
            </template>
          </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-sm btn-success pull-right" style="width:100px" data-dismiss="modal" v-if="success">OK</button>
          <button class="btn btn-sm btn-danger pull-right" style="width:100px" v-if="!success" :disabled="isDisabled" @click="addPassage()">実行</button>
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div>
  </div>
</template>

<script>
import * as Config from '../../config'
import moment from 'moment'

export default {
  data () {
    return {
      list: null,
      errorMessageLogs: '',
      message: 'データー取得中',
      checkedColumnNames: [
        'groupName',
        'status',
        'registered'
      ],
      listGateGroup: {},
      countlistGateGroup: {},
      listUserGroup: {},
      countlistUserGroup: {},
      scorp: ['groupId', 'name'],
      userId: '',
      total: 0,
      selected: 100,
      pages: 0,
      error: null,
      pageSizeOptions: [25, 50, 100, 1000],
      listQuery: {
        currPage: 1,
        pageSize: 100
      },
      selectedGroupId: [],
      existGroupId: [],
      loading: false,
      isDisabled: false,
      progress: 0,
      success: false,
      errorMessage: [],
      successGateGroup: 0,
      errorName: '',
      countGateGroup: 0,
      exeCount: 0,
      percent: 0
    }
  },
  // countGateGroupとはチェックしたアイテム数。
  // exeCountとはAPI実行回数、デフォルトの値は０です。
  // 一回APIを実行が終わるとexeCountに１をプラスする。
  // 全部APIを実行が終わるとexeCountの値は０にリセットする。
  // exeCount<countGateGroupの時は次のAPI実行。
  // exeCount===countGateGroupの時(全部APIを実行が終わったの時)は変数の値リセットする。
  watch: {
    'checkedColumnNames': 'updateChecked',
    exeCount: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.countGateGroup) {
        vm.addPassageToUser(this.selectedGroupId[newVal], vm.percent, newVal)
      } else if (newVal > 0 && newVal === vm.countGateGroup) {
        this.exeCount = 0
        this.success = true
        this.selectedGroupId = []
      }
    }
  },
  created () {
    if (typeof localStorage.pageSizePassageAdd === 'undefined') {
      localStorage.setItem('pageSizePassageAdd', 100)
      this.selected = localStorage.pageSizePassageAdd
    } else {
      this.selected = localStorage.pageSizePassageAdd
    }
    if (typeof localStorage.groupPassAddSortKey === 'undefined') {
      localStorage.setItem('groupPassAddSortKey', 'registered')
    }
    if (typeof localStorage.groupPassAddSortName === 'undefined') {
      localStorage.setItem('groupPassAddSortName', 'desc')
    }
    if (typeof localStorage.checkedUserPassAdd === 'undefined') {
      localStorage.setItem('checkedUserPassAdd', this.checkedColumnNames)
    } else {
      var tempData = []
      this.checkedColumnNames.forEach(function (item) {
        if (localStorage.checkedUserPassAdd.indexOf(item) !== -1) {
          tempData.push(item)
        }
      })
      this.checkedColumnNames = tempData
    }
    this.getList()
    this.fetchData()
  },
  mounted () {
    var vm = this
    $('#nav-search-input').keyup(function (e) {
      if (e.keyCode === 13) {
        vm.search()
      }
    })
  },
  computed: {
    progressWidth: function () {
      return 'width:' + this.progress + '%'
    },
    selectAll: {
      get: function () {
        // true：帰ってきたら一番上の全件チェックボックスはチェックをつける。
        // false：帰ってきたら一番上の全件チェックボックスはチェックをつけない。
        // selectedGroupIdとは、ユーザーがチェックボックスをチェックした数。
        // selectedGroupIdが0より大きい時はチェックをつけない（false）
        // selectedGroupIdが１以上の時は、次のロジックで判定する。
        // existItemとは、カレントページで元々チェックされているチェックボックスの数。
        // list.lengthとは「ページオプション」の「ページことに表示する項目」の数値。
        // selectedGroupId + existItemの結果が、list.length以上であれば、true、list.length未満であれば、false。
        if (this.selectedGroupId.length > 0) {
          var existItem = $('tr.existItem').length
          return this.list ? (this.selectedGroupId.length + existItem) >= this.list.length : false
        } else {
          return false
        }
      },
      set: function (value) {
        var vm = this
        var selectedGroupId = []
        if (value) {
          this.list.forEach(function (item) {
            if (!vm.rowSelectedExistPassage(item.groupId)) {
              selectedGroupId.push(item.groupId)
            }
          })
        }
        this.selectedGroupId = selectedGroupId
      }
    }
  },
  methods: {
    updateChecked () {
      localStorage.setItem('checkedUserPassAdd', this.checkedColumnNames)
    },
    checkColumnShowHide (columnName) {
      if (localStorage.checkedUserPassAdd.indexOf(columnName) !== -1) {
        return false
      } else {
        return true
      }
    },
    cancel () {
      this.$router.push({name: 'useredit', query: { id: this.userId }})
    },
    fetchData () {
      var data = this.$route.query
      this.userId = data.id
      this.getInforUserPassage(this.userId)
    },
    getInforUserPassage (userId) {
      this.$http.get(Config.GROUPS_PASSAGE_API + '?userId=' + encodeURIComponent(userId))
        .then(response => {
          var dataPassage = response.body.groupPassages
          var selectedGroupId = []
          if (dataPassage.length > 0) {
            for (var i = 0; i < dataPassage.length; i++) {
              selectedGroupId.push(dataPassage[i].groupId)
            }
          }
          this.existGroupId = selectedGroupId
        })
        .catch((error) => {
          console.log(error)
        })
    },
    resetStatus () {
      $('.progress').addClass('hide')
      $('.progress-question').html('チェックしたゲートグループを追加する、よろしいですか？')
      this.progress = 0
      this.success = false
      this.isDisabled = false
      this.errorMessage = []
      this.successGateGroup = 0
      this.countGateGroup = 0
    },
    rowSelectedExistPassage (groupId) {
      if (jQuery.inArray(groupId, this.existGroupId) !== -1) {
        return true
      } else {
        return false
      }
    },
    rowSelected (groupId) {
      if (jQuery.inArray(groupId, this.selectedGroupId) !== -1) {
        return true
      } else {
        return false
      }
    },
    addPassageToUser (groupId, percent, i) {
      var vm = this
      console.log(groupId)
      console.log(this.userId)
      this.$http.post(Config.GROUPS_PASSAGE_API, {groupId: groupId, userId: this.userId})
        .then(response => {
          vm.progress += percent
          vm.successGateGroup += 1
          vm.exeCount++
          vm.existGroupId.push(groupId)
        })
        .catch((error) => {
          this.progress += percent
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                this.errorName = ''
              } else {
                this.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 400:
              this.errorName = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorName = 'ゲート関連付け情報の追加権限がありません。'
              break
            case 404:
              this.errorName = '該当するデーターがありません。'
              break
            case 409:
              this.errorName = '入力されたゲートは既に関連付けされています。'
              break
            case 420:
              this.errorName = 'ゲート登録数が上限に達しています。'
              break
            case 500:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
          var rowstatus = groupId + '>><span>' + this.errorName + '</span>'
          this.$set(this.errorMessage, i, rowstatus)
          vm.exeCount++
        })
    },
    addPassage () {
      var vm = this
      vm.isDisabled = true
      if (this.selectedGroupId.length > 0) {
        this.countGateGroup = this.selectedGroupId.length
        $('.progress').removeClass('hide')
        $('.progress-question').html('処理状況')
        vm.percent = (100 / this.selectedGroupId.length)
        vm.addPassageToUser(this.selectedGroupId[0], vm.percent, 0)
      } else {
        alert('少なくてもゲートグールプを１つ選んでください。')
      }
    },
    addRomoveScorp (classname, scorpname) {
      if ($('.' + classname).prop('checked')) {
        this.scorp.push(scorpname)
      } else {
        this.scorp.splice($.inArray(scorpname, this.scorp), 1)
      }
    },
    search () {
      this.loading = true
      this.errorMessageLogs = ''
      if (this.scorp.length > 0) {
        window.scrollTo(0, 0)
        this.listQuery.currPage = 1
        this.pages = 0
        var keyword = $('.nav-search-input').val()
        keyword = keyword.replace(/\s/g, ',')
        keyword = encodeURIComponent(keyword)
        this.$http.get(Config.GROUPS_LIST_API + '?limit=' + localStorage.pageSizePassageAdd + '&page=' + this.listQuery.currPage + '&sortKey=' + localStorage.groupPassAddSortName + ':' + localStorage.groupPassAddSortKey + '&keyword=' + keyword + '&scorp=' + this.scorp + '&isValid=true')
          .then(response => {
            if (response.body.maxRecords > 0) {
              this.loading = false
              this.pages = Math.ceil((response.body.maxRecords) / localStorage.pageSizePassageAdd)
              this.list = response.body.groups
              console.log(response)
            } else {
              this.loading = false
              this.list = null
              this.pages = 0
              this.message = '該当するデーターがありません。'
            }
          })
          .catch((error) => {
            this.loading = false
            this.list = null
            this.pages = 0
            this.message = '該当するデーターがありません。'
            switch (error.status) {
              case 401:
                if (error.body.message === 'The incoming token has expired') {
                  this.errorMessageLogs = ''
                } else {
                  this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                }
                break
              case 400:
                this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                break
              case 403:
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
              case 404:
                this.errorMessageLogs = '該当するデーターがありません。'
                break
              case 500:
                this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              case 503:
                this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              default:
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
            }
          })
      } else {
        alert('少なくても検索項目を１つ選んでください。')
        this.loading = false
      }
    },
    sort (sortkey, elementname) {
      this.loading = true
      if ($('#' + elementname).hasClass('sorting_asc')) {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_asc')
        $('#' + elementname).addClass('sorting_desc')
        localStorage.setItem('groupPassAddSortName', 'desc')
        localStorage.setItem('groupPassAddSortKey', sortkey)
      } else {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_desc')
        $('#' + elementname).addClass('sorting_asc')
        localStorage.setItem('groupPassAddSortName', 'asc')
        localStorage.setItem('groupPassAddSortKey', sortkey)
      }
      this.getList()
    },
    handleEdit (id) {
      this.$router.push({name: 'groupedit', query: { id: id }})
    },
    handleSizeChange () {
      this.listQuery.pageSize = $('#pageSizeOptions').val()
      localStorage.setItem('pageSizePassageAdd', this.listQuery.pageSize)
      this.listQuery.currPage = 1
      this.pages = 0
      this.getList()
    },
    handleCurrentChange (val) {
      this.selectedGroupId = []
      this.listQuery.currPage = val
      this.getList()
      window.scrollTo(0, 0)
    },
    randomAcountClass (classname) {
      return 'acount' + classname
    },
    randomAcountHref (classname) {
      return '#acount' + classname
    },
    randomDeviceClass (classname) {
      return 'device' + classname
    },
    randomDeviceHref (classname) {
      return '#device' + classname
    },
    randomGateClass (classname) {
      return 'gate' + classname
    },
    randomGateHref (classname) {
      return '#gate' + classname
    },
    converDate (t) {
      return moment(new Date(t * 1000)).format('YYYY/MM/DD')
    },
    converTimestamp (t) {
      return parseInt(new Date(t) / 1000)
    },
    ShowHideColumn: function (e) {
      var $tbl = $('#simple-table')
      var colToHide = $tbl.find('.' + $(e.target).attr('name'))
      $(colToHide).toggle()
    },
    showdetail: function (e) {
    },
    getList () {
      this.loading = true
      this.errorMessageLogs = ''
      if (this.list !== null) {
        var keyword = $('.nav-search-input').val()
        keyword = keyword.replace(/\s/g, ',')
        keyword = encodeURIComponent(keyword)
      } else {
        keyword = ''
      }
      this.$http.get(Config.GROUPS_LIST_API + '?limit=' + localStorage.pageSizePassageAdd + '&page=' + this.listQuery.currPage + '&sortKey=' + localStorage.groupPassAddSortName + ':' + localStorage.groupPassAddSortKey + '&keyword=' + keyword + '&scorp=' + this.scorp + '&isValid=true')
        .then(response => {
          if (response.body.maxRecords > 0) {
            this.loading = false
            this.pages = Math.ceil((response.body.maxRecords) / localStorage.pageSizePassageAdd)
            this.list = response.body.groups
            console.log(response)
          } else {
            this.loading = false
            this.list = null
            this.pages = 0
            this.message = '該当するデーターがありません。'
          }
        })
        .catch((error) => {
          this.loading = false
          this.list = null
          this.pages = 0
          this.message = '該当するデーターがありません。'
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                this.errorMessageLogs = ''
              } else {
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 400:
              this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
            case 404:
              this.errorMessageLogs = '該当するデーターがありません。'
              break
            case 500:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
        })
    }
  }
}
</script>

<style>
.checkbox label, .radio label {
  padding-left: 10px!important
}
.checkbox-box{
  margin-right: 15px
}
.edit-bottom,.delete-bottom{
  width: 100%;
  margin-bottom: 15px
}
.fa-6{
  font-size: 3em;
}
.fa-3{
  font-size: 2em;
}
.table>tbody>tr>td{
  vertical-align: middle;
  padding: 5px;
  font-size: 16px;
}
.dataTables_paginate .pagination {
  margin: 0;
}
.table-bordered>tbody>tr>td{
  border-right:3px solid #fff;
}
.label-sm {
  padding: 10px;
  font-size: 16px;
  line-height: 1;
  height: auto;
}
.table-detail .profile-info-name{
  width: 195px
}
.device{
  margin-top: 50px;
  border-top: 2px solid #ccc
}
.table-detail .accordion-style1.panel-group .panel-heading .accordion-toggle.collapsed{
  font-size: 18px
}
.table-detail .accordion-style1.panel-group .panel-heading .accordion-toggle{
  font-size: 18px
}
.add-buttom{
  margin-bottom: 10px
}
.modal-content .form-horizontal .control-label{
  text-align: left;
}
.chosen-container-single .chosen-single{
  border-radius: 0px;
  height: 35px;
  font-size: 16px;
  line-height: 35px!important;
}
.chosen-container-single{
  width: 100%!important
}
.chosen-container{
  margin-bottom: 10px
}
.dataTable>thead>tr>th[class*=sorting_]{
  color: #707070
}
.modal-content .form-horizontal .control-label{
  text-align: left;
}
.chosen-container-single .chosen-single{
  border-radius: 0px;
  height: 35px;
  font-size: 16px;
  line-height: 35px!important;
}
.chosen-container-single{
  width: 100%!important
}
.chosen-container{
  margin-bottom: 10px
}
.dataTable>thead>tr>th[class*=sorting_]{
  color: #707070
}
</style>



// WEBPACK FOOTER //
// src/views/user/UserPassageAdd.vue